/**
 * Dashboard widget factories — clock.
 */
import { registerDashboard } from '../registryCore';
import { createWidgetGroup, num, setParts, setRefresh, setState, bool, } from '../helpers';
import { getActiveDashboard } from '../theme';
registerDashboard('clock', function (props, app) {
    var size = num(props, 'size', 120);
    var live = bool(props, 'live', true);
    var showSeconds = bool(props, 'showSeconds', size >= 44);
    var group = createWidgetGroup(app, 'clock', props, { width: size, height: size });
    var cx = size / 2;
    var r = size / 2 - 3;
    var pad = Math.max(2, size * 0.04);
    var hourLen = (r - pad) * 0.5;
    var minLen = (r - pad) * 0.72;
    var secLen = (r - pad) * 0.82;
    var hourW = Math.max(2, size * 0.035);
    var minW = Math.max(1.5, size * 0.025);
    var hubR = Math.max(3, size * 0.05);
    group.add(app.circle({
        x: cx - r,
        y: cx - r,
        radius: r,
        fill: getActiveDashboard().clockFace,
        stroke: getActiveDashboard().clockRing,
        strokeWidth: Math.max(1.5, size / 50),
        shadow: size >= 56 ? { color: 'rgba(0,0,0,0.35)', blur: 5, offsetX: 0, offsetY: 2 } : undefined,
        listening: false,
    }));
    for (var i = 0; i < 12; i++) {
        var a = (i / 12) * Math.PI * 2 - Math.PI / 2;
        var major = i % 3 === 0;
        var tickLen = major ? size * 0.1 : size * 0.06;
        var inner = r - tickLen;
        var outer = r - size * 0.03;
        var cos = Math.cos(a);
        var sin = Math.sin(a);
        group.add(app.line({
            x: cx + inner * cos,
            y: cx + inner * sin,
            x2: (outer - inner) * cos,
            y2: (outer - inner) * sin,
            stroke: major ? getActiveDashboard().clockTickMajor : getActiveDashboard().clockTick,
            strokeWidth: major ? Math.max(1.5, size / 40) : 1,
            lineCap: 'round',
            listening: false,
        }));
    }
    var hourHand = app.line({
        x: cx,
        y: cx,
        x2: 0,
        y2: -hourLen,
        stroke: getActiveDashboard().clockHand,
        strokeWidth: hourW,
        lineCap: 'round',
        listening: false,
    });
    var minHand = app.line({
        x: cx,
        y: cx,
        x2: 0,
        y2: -minLen,
        stroke: getActiveDashboard().clockHand,
        strokeWidth: minW,
        lineCap: 'round',
        listening: false,
    });
    var secHand = app.line({
        x: cx,
        y: cx,
        x2: 0,
        y2: -secLen,
        stroke: getActiveDashboard().clockSecond,
        strokeWidth: Math.max(1, size * 0.015),
        lineCap: 'round',
        visible: showSeconds,
        listening: false,
    });
    group.add(hourHand, minHand, secHand);
    group.add(app.circle({
        x: cx - hubR,
        y: cx - hubR,
        radius: hubR,
        fill: getActiveDashboard().clockHub,
        stroke: getActiveDashboard().clockRing,
        strokeWidth: 1,
        listening: false,
    }), app.circle({
        x: cx - hubR * 0.45,
        y: cx - hubR * 0.45,
        radius: hubR * 0.45,
        fill: getActiveDashboard().clockHand,
        listening: false,
    }));
    var updateHands = function () {
        var now = new Date();
        var hours = now.getHours() % 12;
        var minutes = now.getMinutes();
        var seconds = now.getSeconds();
        var hourAngle = ((hours + minutes / 60) / 12) * Math.PI * 2 - Math.PI / 2;
        var minAngle = ((minutes + seconds / 60) / 60) * Math.PI * 2 - Math.PI / 2;
        var secAngle = (seconds / 60) * Math.PI * 2 - Math.PI / 2;
        hourHand.x2 = hourLen * Math.cos(hourAngle);
        hourHand.y2 = hourLen * Math.sin(hourAngle);
        minHand.x2 = minLen * Math.cos(minAngle);
        minHand.y2 = minLen * Math.sin(minAngle);
        if (showSeconds) {
            secHand.x2 = secLen * Math.cos(secAngle);
            secHand.y2 = secLen * Math.sin(secAngle);
        }
    };
    updateHands();
    setParts(group, { hourHand: hourHand, minHand: minHand, secHand: secHand });
    if (live) {
        setRefresh(group, function () { return updateHands(); });
    }
    setState(group, { size: size, live: live, showSeconds: showSeconds });
    return group;
});
